<script setup>
import {ref, onMounted, onBeforeUnmount, getCurrentInstance, inject} from 'vue'

const localMessage = ref(null)
const color = ref('')
const progressBg = ref('')
const progressBorder = ref('')
const id = ref(1)
const timer_remain_percent = ref(0)
const timer_counter = ref(0)
const is_showing = ref(false)
const dismissable = ref(true)
const auto_dismiss = ref(true)
const $emitter = inject('emitter');
let timer = null

function showMessage(msg, timeout) {
  id.value++
  is_showing.value = true
  if (timer) {
    clearInterval(timer)
  }
  localMessage.value = msg ?? null
  if (auto_dismiss.value) {
    timer_counter.value = timeout
    timer = setInterval(() => {
      timer_counter.value -= 100
      timer_remain_percent.value = (timer_counter.value * 100) / timeout
      if (timer_counter.value <= 0) {
        clearInterval(timer)
        is_showing.value = false
      }
    }, 100)
  }
}

onMounted(() => {
  $emitter.on('messages.show_error', (msg, timeout = 4000) => {
    color.value = 'bg-rose-200 border-rose-500 text-rose-800'
    progressBg.value = 'bg-rose-800'
    progressBorder.value = 'border-rose-800'
    showMessage(msg, timeout)
  })
  $emitter.on('messages.show_success', (msg, timeout = 4000) => {
    color.value = 'bg-emerald-200 border-emerald-500 text-emerald-800'
    progressBg.value = 'bg-emerald-800'
    progressBorder.value = 'border-emerald-800'
    showMessage(msg, timeout)
  })
  $emitter.on('messages.show_warning', (msg, timeout = 4000) => {
    color.value = 'bg-amber-200 border-amber-500 text-amber-800'
    progressBg.value = 'bg-amber-800'
    progressBorder.value = 'border-amber-800'
    showMessage(msg, timeout)
  })
})

onBeforeUnmount(() => {
  if (timer) {
    clearInterval(timer)
  }
})
</script>

<template>
  <div>
    <transition name="slide-fade">
      <div v-if="is_showing"
           class="min-w-[400px] opacity-95 max-w-[400px] fixed bottom-5 right-5 p-0 z-[2001] rounded-lg border-2"
           :class="[color]" :key="id">
        <div class="flex flex-row h-full">
          <div class="grow px-5 py-4 leading-5 font-medium">
            {{ localMessage }}
          </div>
          <div v-if="dismissable" class="p-2">
            <div class="rounded-full border h-full flex items-end w-[5px]" :class="[progressBorder]">
              <div class="w-full transition-all" :class="[progressBg]" :style="{height: timer_remain_percent + '%'}"></div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(100%);
  opacity: 0;
}

.slide-fade-enter-to,
.slide-fade-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
}
</style>
